import { Injectable } from '@angular/core';
import { AppService } from "../../core/services/app.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})

export class NotificationService {
  constructor(public http: HttpClient) {
  }
  
  createNotification(data) {
    return this.http.post(AppService.getApiUrl() + '/api/notifications/push-notification/', data);
  }
}
